import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Redux Saga
import {
  GET_DISCOUNT_TYPES_SUCCESS,
  GET_DISCOUNT_TYPES_FAIL,
  CREATE_DISCOUNT_TYPE_SUCCESS,
  CREATE_DISCOUNT_TYPE_FAIL,
} from "./actionTypes"

// Discount types actions
import { getDiscountTypes as getDiscountTypesAction } from "./actions"

// API functions
import {
  getDiscountTypes,
  createDiscountType,
} from "../../helpers/backend_helper"

// Toast for notifications
import { toast } from "react-toastify"

// Get all discount types
function* fetchDiscountTypes({ payload: { history } }) {
  try {
    const response = yield call(getDiscountTypes)
    yield put({ type: GET_DISCOUNT_TYPES_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_DISCOUNT_TYPES_FAIL, payload: error })
    toast.error("Failed to load discount types")
  }
}

// Create discount type
function* onCreateDiscountType({ payload: { discountType, history } }) {
  try {
    const response = yield call(createDiscountType, discountType)
    yield put({ type: CREATE_DISCOUNT_TYPE_SUCCESS, payload: response })
    toast.success("Discount type created successfully!")
    // Refresh the discount types list
    yield put(getDiscountTypesAction(history))
  } catch (error) {
    yield put({ type: CREATE_DISCOUNT_TYPE_FAIL, payload: error })
    toast.error("Failed to create discount type")
  }
}

// Watchers
function* getDiscountTypesSaga() {
  yield takeEvery("GET_DISCOUNT_TYPES", fetchDiscountTypes)
}

function* createDiscountTypeSaga() {
  yield takeEvery("CREATE_DISCOUNT_TYPE", onCreateDiscountType)
}

// Export all sagas
function* discountTypesSaga() {
  yield all([
    fork(getDiscountTypesSaga),
    fork(createDiscountTypeSaga),
  ])
}

export default discountTypesSaga
